import React from "react";
import { getTranslation } from "../../../assets/creator/translations";

function BottomMenu() {
    return (
        <div className="phone-frame__bottomMenu primaryPageBgColor--bg">
            <svg width="365" height="62" viewBox="0 0 365 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Nawigacja mobile">
                    <g id="Frame 483">
                        <rect width="365" height="62" fill="#FFF"/>
                        <g id="Frame 466">
                            <g id="Navigation/Home" transform="translate(22.000 9.000)">
                                <use className="primaryColorFont" xlinkHref="#home" width="22" height="22"></use>
                            </g>
                            <text id="Start" className="primaryColorFont" fontFamily="Inter" fontSize="11" letterSpacing="0px">
                                <tspan x="20.1631" y="49">{getTranslation("MobileStart")}</tspan>
                            </text>
                        </g>
                        <g id="Frame 468">
                            <g id="Interface/Cart 1" transform="translate(95.000 9.000)">
                                <use className="primaryColorFont" xlinkHref="#shopping-cart" width="22" height="22"></use>
                            </g>
                            <g id="Interface/Number">
                                <rect x="112" y="3.5" width="16" height="16" rx="8" className="headerCounterBgColor"/>
                                <text id="Interface/NumberText" className="headerCounterFontColor" fontFamily="Inter" fontSize="11" letterSpacing="0px">
                                    <tspan x="117" y="15.6">9</tspan>
                                </text>
                            </g>
                            <text id="Koszyk" className="primaryColorFont" fontFamily="Inter" fontSize="11" letterSpacing="0px">
                                <tspan x="87.9482" y="49">{getTranslation("MobileCart")}</tspan>
                            </text>
                        </g>
                        <g id="Frame 469">
                            <g id="Interface/Bars" transform="translate(169.000 9.000)">
                                <use className="primaryColorFont" xlinkHref="#bars" width="22" height="22"></use>
                            </g>
                            <text id="Menu" className="primaryColorFont" fontFamily="Inter" fontSize="11" letterSpacing="0px">
                                <tspan x="165.493" y="49">{getTranslation("MobileMenu")}</tspan>
                            </text>
                        </g>
                        <g id="Frame 470">
                            <g id="Interface/User" transform="translate(246.000 9.000)">
                                <use className="primaryColorFont" xlinkHref="#user" width="22" height="22"></use>
                            </g>
                            <text id="Panel klienta" className="primaryColorFont" fontFamily="Inter" fontSize="11" letterSpacing="0px">
                                <tspan x="225.597" y="49">{getTranslation("MobileProfile")}</tspan>
                            </text>
                        </g>
                        <g id="Frame 472">
                            <g id="Interface/More" transform="translate(316.000 9.000)">
                                <use className="primaryColorFont" xlinkHref="#ellipsis-h" width="22" height="22"></use>
                            </g>
                            <text id="Wiecej" className="primaryColorFont" fontFamily="Inter" fontSize="11" letterSpacing="0px">
                                <tspan x="309.694" y="49">{getTranslation("MobileMore")}</tspan>
                            </text>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
}

export default BottomMenu;